export default function CustomerCreditLogsTable({
  logs = [],
  loading = false,
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
}) {
  const dataRows = Array.isArray(logs) ? logs : [];

  return (
    <div className="rounded-lg border bg-white dark:bg-gray-900 dark:border-gray-700">
      <div className="p-4 border-b dark:border-gray-700">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Riwayat Credit
        </h3>
        <p className="text-xs text-gray-500 mt-1">
          Total: {totalItems} item(s) | Halaman {currentPage} dari {totalPages}
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100 dark:bg-gray-800">
            <tr>
              <th className="px-4 py-2 text-left">Tanggal</th>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Source</th>
              <th className="px-4 py-2 text-right">Amount</th>
              <th className="px-4 py-2 text-right">Balance After</th>
              <th className="px-4 py-2">Ref</th>
              <th className="px-4 py-2">Notes</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="px-4 py-4 text-center text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : dataRows.length === 0 ? (
              <tr>
                <td colSpan="7" className="px-4 py-4 text-center text-gray-500">
                  Tidak ada data
                </td>
              </tr>
            ) : (
              dataRows.map((row) => (
                <tr
                  key={row.id}
                  className="border-t dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  <td className="px-4 py-2">
                    {new Date(row.created_at).toLocaleString("id-ID")}
                  </td>
                  <td
                    className={`px-4 py-2 font-semibold ${
                      row.type === "IN"
                        ? "text-green-600"
                        : row.type === "OUT"
                        ? "text-red-600"
                        : "text-yellow-600"
                    }`}
                  >
                    {row.type}
                  </td>
                  <td className="px-4 py-2">{row.source}</td>
                  <td className="px-4 py-2 text-right">
                    Rp{" "}
                    {(row.type === "OUT" ? "-" : "") +
                      Number(row.amount).toLocaleString("id-ID")}
                  </td>
                  <td className="px-4 py-2 text-right">
                    Rp {Number(row.balance_after).toLocaleString("id-ID")}
                  </td>
                  <td className="px-4 py-2">{row.reference_id || "-"}</td>
                  <td className="px-4 py-2">{row.notes || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination Sederhana */}
      {totalPages > 1 && (
        <div className="p-4 border-t dark:border-gray-700 flex justify-between items-center">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-200 dark:bg-gray-700 disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-sm">
            Halaman {currentPage} dari {totalPages}
          </span>
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 bg-gray-200 dark:bg-gray-700 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
